import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { render } from 'react-dom';
import App from './app';
import { Provider } from 'react-redux';
import { setupStore } from './redux/store';
import './index.scss';
import './components/images';
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
const resizeObserverLoopErr = /^ResizeObserver loop completed with undelivered notifications\./;

window.addEventListener('error', (e) => {
    if (resizeObserverLoopErrRe.test(e.message) || resizeObserverLoopErr.test(e.message)) {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
        e.stopImmediatePropagation();
    }
});
render(
    <BrowserRouter basename="/">
        <Provider store={setupStore()}>
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('app'),
);
